import {garageLocatorData} from './garageLocator';
import getLabels from '../globals/labels';

export default function contactGarage() {
    let workingHours = garageLocatorData.workingHours;
    // Add working hours to contact form
    let workingHoursElement = document.querySelectorAll('.c-qt-contact__working-time');

    if (workingHoursElement) {
        workingHoursElement.forEach((el) => {
            let day = el.getAttribute('data-day');

            if (workingHours[day].length > 0) {
                workingHours[day].forEach((hours, index) => {
                    workingHours[day][index]['open'] = hours['open'].replace(/(\d{2})(\d{2})/, '$1:$2');
                    workingHours[day][index]['close'] = hours['close'].replace(/(\d{2})(\d{2})/, '$1:$2');
                });
                // Create working hours string
                let workingHoursString = '';
                workingHours[day].forEach((hours, index) => {
                    workingHoursString += hours.open + ' - ' + hours.close;
                    if (index < workingHours[day].length - 1) {
                        workingHoursString += ' ';
                    }
                });

                // If garage is closed on that day add class to li element
                if (workingHoursString === 'closed') {
                    el.classList.add('c-qt-contact__working-time--closed');
                }
                // Add working hours to DOM
                el.querySelector('span:last-child').textContent = workingHoursString;
            } else {
                el.classList.add('c-qt-contact__working-time--closed');
                el.querySelector('span:last-child').textContent = getLabels().closed;
            }
        });
    }

    let title = garageLocatorData.name;
    if (title) {
        let titleEl = document.querySelector('.c-qt-contact__title');
        if (titleEl) {
            // before title and after is a label getLabels().contact and getLabels().directly also add <span> only around title
            titleEl.innerHTML = getLabels().contact + ' ' + getLabels().directly + ' <span>' + title + '</span> ';
        }

    }


    // Add open status to contact form
    let openStatusElement = document.querySelector('.c-qt-contact__open');
    let openStatus = garageLocatorData.open;
    let openStatusString = '';
    if (openStatus) {
        openStatusString = getLabels().open;
    } else {
        openStatusString = getLabels().closed;
    }
    if (openStatusElement) {
        openStatusElement.textContent = openStatusString;
        // Add class to open status element
        if (openStatus) {
            openStatusElement.classList.add('c-qt-contact__open--open');
        } else {
            openStatusElement.classList.add('c-qt-contact__open--closed');
        }
    }

    let telephoneEl = document.querySelector('.c-qt-contact__tp');
	if (telephoneEl && garageLocatorData.phone) {
		const phone = garageLocatorData.phone;

		// Insert two spans to "break" the phone pattern
		telephoneEl.innerHTML = phone;

		// If you were setting an href for a tel link, comment it out
		// telephoneEl.setAttribute('href', 'tel:' + phone);
	}

}
